
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe01 as ObiHydraulicPipe01Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-01.js';
 
 
 

 
 export const ObiHydraulicPipe01 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-01',
   elementClass: ObiHydraulicPipe01Element,
   events: {
     
   }
  });
 
 